import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tabs, Tab, Table, Modal, Button } from "react-bootstrap";

export default function CashManagement() {
  const [registers, setRegisters] = useState([]);
  const [transactions, setTransactions] = useState([]);

  const userdata = localStorage.getItem("USER_data");
  const userData = JSON.parse(userdata);
  const userid = userData.id;
const [filters, setFilters] = useState({
  RegisterID: "",
  FromDate: "",
  ToDate: "",
});
  // ---------------- State ----------------
  const [newRegister, setNewRegister] = useState({
    RegisterName: "",
    InitialBalance: 0,
    Currency: "LYD",
    Notes: "",
  });

  const [newTransaction, setNewTransaction] = useState({
    RegisterID: "",
    TransactionDate: "",
    Description: "",
    AmountIn: 0,
    AmountOut: 0,
    TransactionType: "in",
    PaymentMethod: "cash",
    UserID: userid,
  });

  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [showTransactionForm, setShowTransactionForm] = useState(false);

  const [editRegister, setEditRegister] = useState(null);
  const [editTransaction, setEditTransaction] = useState(null);

  // ---------------- API ----------------
  const fetchRegisters = async () => {
    const res = await axios.get("https://subk.education.com.ly/back/api/registers");
    setRegisters(res.data);
  };

 const fetchTransactions = async () => {
  // If no filters set, do nothing
  if (!filters.RegisterID && !filters.FromDate && !filters.ToDate) {
    setTransactions([]); // optional: clear table
    return;
  }

  const res = await axios.get("https://subk.education.com.ly/back/api/transactions", {
    params: filters,
  });
  setTransactions(res.data);
};
  useEffect(() => {
    fetchRegisters();
    fetchTransactions();
  }, []);

  const saveRegister = async () => {
    if (editRegister) {
      await axios.put(
        `https://subk.education.com.ly/back/api/registers/${editRegister.RegisterID}`,
        newRegister
      );
      setEditRegister(null);
    } else {
      await axios.post("https://subk.education.com.ly/back/api/registers", newRegister);
    }
    setNewRegister({
      RegisterName: "",
      InitialBalance: 0,
      Currency: "LYD",
      Notes: "",
    });
    setShowRegisterForm(false);
    fetchRegisters();
  };

  const saveTransaction = async () => {
    if (editTransaction) {
      await axios.put(
        `https://subk.education.com.ly/back/api/transactions/${editTransaction.TransactionID}`,
        newTransaction
      );
      setEditTransaction(null);
    } else {
      await axios.post("https://subk.education.com.ly/back/api/transactions", newTransaction);
    }
    setNewTransaction({
      RegisterID: "",
      TransactionDate: "",
      Description: "",
      AmountIn: 0,
      AmountOut: 0,
      TransactionType: "in",
      PaymentMethod: "cash",
      UserID: userid,
    });
    setShowTransactionForm(false);
    fetchTransactions();
  };

  // ---------------- UI ----------------
  return (
    <div className="container-fluid" style={{ padding: "0.5rem" }}>
           <div className="row">
            <div className="col-xl-12">
                
            <div className="card">
            <div className="card-header">
                <h4 className="heading mb-0">عمليات الصيانة</h4>
                
                                     
              </div>     
              
                       
      <Tabs defaultActiveKey="registers" >
        {/* ---------------- Registers ---------------- */}
        <Tab eventKey="registers" title="الخزائن"  className="p-3">
          <div className="row">
            <div className="col-xl-12">
                
              {!showRegisterForm ? (
                  <div className="col-xl-12 pb-3 d-flex   justify-content-end   ">

                <button
                  className="btn btn-success me-0"
                  onClick={() => setShowRegisterForm(true)}
                >
                  + إضافة خزنة
                </button>
                </div>
              ) : (
                   <div className="">
                    <h5 className="mb-3">
                      {editRegister ? "تعديل خزنة" : "إضافة خزنة"}
                    </h5>
                    {/* ---------------- Form ---------------- */}
                    <form>
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="form-label">اسم الخزنة</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newRegister.RegisterName}
                            onChange={(e) =>
                              setNewRegister({
                                ...newRegister,
                                RegisterName: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="form-label">الرصيد الافتتاحي</label>
                          <input
                            type="number"
                            className="form-control"
                            value={newRegister.InitialBalance}
                            onChange={(e) =>
                              setNewRegister({
                                ...newRegister,
                                InitialBalance: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="form-label">العملة</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newRegister.Currency}
                            onChange={(e) =>
                              setNewRegister({
                                ...newRegister,
                                Currency: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 mb-2">
                          <label className="form-label">ملاحظات</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newRegister.Notes}
                            onChange={(e) =>
                              setNewRegister({
                                ...newRegister,
                                Notes: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm m-1 "
                        onClick={saveRegister}
                      >
                        {editRegister ? "تحديث" : "حفظ"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger light btn-sm m-1"
                        onClick={() => {
                          setShowRegisterForm(false);
                          setEditRegister(null);
                        }}
                      >
                        إلغاء
                      </button>
                    </form>
                  </div>
               )}
            </div>
          </div>

                             <Table striped bordered hover>
            <thead>
              <tr>
                <th>المعرف</th>
                <th>اسم الخزنة</th>
                <th>الرصيد</th>
                <th>العملة</th>
                <th>ملاحظات</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {registers.map((r) => (
                <tr key={r.id}>
                  <td>{r.id}</td>
                  <td>{r.RegisterName}</td>
                  <td>{r.InitialBalance}</td>
                  <td>{r.Currency}</td>
                  <td>{r.Notes}</td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => {
                        setNewRegister(r);
                        setEditRegister(r);
                        setShowRegisterForm(true);
                      }}
                    >
                      تعديل
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
              </Tab>

        {/* ---------------- Transactions ---------------- */}
        <Tab eventKey="transactions" title="الحركات" className="p-3">
          <div className="row">
<div className=" col-xl-12 row d-flex    ">          
 {!showTransactionForm ? (
  <div className="col-xl-12 pb-3 d-flex align-items-center justify-content-between mt-2 flex-wrap">

    {/* Filters (right side) */}
    <div className="col-xl-8 d-flex flex-wrap align-items-center  me-3 gap-2">

      {/* Register Filter */}
      <div className="d-flex align-items-center gap-2">
        <label className="form-label mb-0">الخزنة</label>
        <select
          className="form-control form-control-sm"
          value={filters.RegisterID}
          onChange={(e) =>
            setFilters({ ...filters, RegisterID: e.target.value })
          }
          style={{ width: "150px" }}
        >
          <option value="">الكل</option>
          {registers.map((r) => (
            <option key={r.RegisterID} value={r.RegisterID}>
              {r.RegisterName}
            </option>
          ))}
        </select>
      </div>

      {/* From Date */}
      <div className="d-flex align-items-center gap-2">
        <label className="form-label mb-0">من</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={filters.FromDate}
          onChange={(e) =>
            setFilters({ ...filters, FromDate: e.target.value })
          }
          style={{ width: "160px" }}
        />
      </div>

      {/* To Date */}
      <div className="d-flex align-items-center gap-2">
        <label className="form-label mb-0">إلى</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={filters.ToDate}
          onChange={(e) =>
            setFilters({ ...filters, ToDate: e.target.value })
          }
          style={{ width: "160px" }}
        />
      </div>

      {/* Buttons */}
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary btn-sm"
          onClick={fetchTransactions}
        >
          تطبيق
        </button>
        <button
          className="btn btn-danger light btn-sm"
          onClick={() => {
            setFilters({ RegisterID: "", FromDate: "", ToDate: "" });
            fetchTransactions();
          }}
        >
          إعادة
        </button>
      </div>
    </div>

    {/* Add Transaction Button (left side) */}
    <div  className="col-xl-3 d-flex justify-content-end ms-3">
      <button
        className="btn btn-success btn-sm"
        onClick={() => setShowTransactionForm(true)}
      >
        + إضافة حركة
      </button>
    </div>

  </div>
) : (


                <div className="row">
                     <h5 className="mb-3">
                      {editTransaction ? "تعديل حركة" : "إضافة حركة"}
                    </h5>
                    {/* ---------------- Transaction Form ---------------- */}
                    <form>
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="form-label">الخزنة</label>
                          <select
                            className="form-control"
                            value={newTransaction.RegisterID}
                            onChange={(e) =>
                              setNewTransaction({
                                ...newTransaction,
                                RegisterID: Number(e.target.value),
                              })
                            }
                          >
                            <option value="">اختر الخزنة</option>
                            {registers.map((r) => (
                              <option key={r.RegisterID} value={r.RegisterID}>
                                {r.RegisterName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="form-label">التاريخ</label>
                          <input
                            type="date"
                            className="form-control"
                            value={newTransaction.TransactionDate}
                            onChange={(e) =>
                              setNewTransaction({
                                ...newTransaction,
                                TransactionDate: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="form-label">الوصف</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newTransaction.Description}
                            onChange={(e) =>
                              setNewTransaction({
                                ...newTransaction,
                                Description: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="form-label">نوع الحركة</label>
                          <select
                            className="form-control"
                            value={newTransaction.TransactionType}
                            onChange={(e) => {
                              const type = e.target.value;
                              setNewTransaction({
                                ...newTransaction,
                                TransactionType: type,
                                AmountIn:
                                  type === "in"
                                    ? newTransaction.AmountIn || 0
                                    : 0,
                                AmountOut:
                                  type === "out"
                                    ? newTransaction.AmountOut || 0
                                    : 0,
                              });
                            }}
                          >
                            <option value="in">إيراد</option>
                            <option value="out">مصروف</option>
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="form-label">القيمة</label>
                         <input
  type="number"
  className="form-control"
  value={
    newTransaction.TransactionType === "in"
      ? newTransaction.AmountIn
      : newTransaction.AmountOut
  }
  onChange={(e) => {
    const value = Number(e.target.value);
    if (newTransaction.TransactionType === "in") {
      setNewTransaction({
        ...newTransaction,
        AmountIn: value,
        AmountOut: 0,
      });
    } else {
      setNewTransaction({
        ...newTransaction,
        AmountOut: value,
        AmountIn: 0,
      });
    }
  }}
/>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="form-label">طريقة الدفع</label>
                          <select
                            className="form-control"
                            value={newTransaction.PaymentMethod}
                            onChange={(e) =>
                              setNewTransaction({
                                ...newTransaction,
                                PaymentMethod: e.target.value,
                              })
                            }
                          >
                            <option value="cash">نقدي</option>
                            <option value="card">بطاقة</option>
                            <option value="bank">تحويل بنكي</option>
                            <option value="cheque">شيك</option>
                          </select>
                        </div>
                      </div>
                      
                      
                      <button
                        type="button"
                        className="btn btn-primary btn-sm m-1 "
                        onClick={saveTransaction}
                      >
                        {editTransaction ? "تحديث" : "حفظ"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger light btn-sm m-1"
                        onClick={() => {
                          setShowTransactionForm(false);
                          setEditTransaction(null);
                        }}
                      >
                        إلغاء
                      </button>
                    </form>
                  </div>
               )}
            </div>
          </div>

   


                           <Table striped bordered hover className="p-3">
            <thead>
              <tr>
                <th>الخزنة</th>
                <th>التاريخ</th>
                <th>الوصف</th>
                <th>إيداع</th>
                <th>سحب</th>
                <th>الرصيد بعد الحركة</th>
                <th>طريقة الدفع</th>
                <th>المستخدم</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              
                  {transactions.length > 0 ? (
transactions.map((t) => (
                <tr key={t.TransactionID}>
                  <td>{t.register?.RegisterName}</td>
                  <td>{t.TransactionDate}</td>
                  <td>{t.Description}</td>
                  <td>{t.AmountIn}</td>
                  <td>{t.AmountOut}</td>
                  <td>{t.BalanceAfterTransaction}</td>
                  <td>{t.PaymentMethod}</td>
                  <td>{t.UserID}</td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => {
                        setNewTransaction(t);
                        setEditTransaction(t);
                        setShowTransactionForm(true);
                      }}
                    >
                      تعديل
                    </Button>
                  </td>
                </tr>
             ))  ) : (
      <tr>
        <td colSpan="9" className="text-center text-muted">
          لا توجد بيانات
        </td>
      </tr>
    )}
            </tbody>
          </Table>
         </Tab>
      </Tabs>
    </div>         
 </div> 
 </div>               </div> 
  );
}
